<template>
  <v-row class="tab-progression ma-0 full-width">
    <v-col
      v-for="i in maxStage"
      :key="i"
      :class="{full: i <= stage}"
      class="tab pa-0"
    >
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Vue, prop } from 'vue-class-component';

class Props {
  stage:number = prop({
    required: true,
  });
  maxStage:number = prop({
    required: true,
  });
}
export default class TabProgression extends Vue.with(Props) {

}
</script>

<style lang="scss" scoped>
@import '@/css/variables';
.tab-progression {
  overflow: hidden;
  border-radius: 8px;
  .tab {
    background-color: $color-neutral-grey-20;
    &:not(:last-of-type) {
      margin-right: 4px;
    }
    &.full {
      background-color: $color-brand;
    }
    height: 12px;
  }

}
</style>
